<template>
  <div class="pay-confirm OrderDetail"
       v-loading="loading"
       element-loading-text="拼命加载中">
    <div class="order-xz"
         style="position:relative;">
      <p class="order-state">
        <i class="fa fa-gou"
           v-if="order.state===2"
           style="color:#00C7BF"></i>
        <i class="fa fa-gantan"
           v-if="order.state!==2"
           :style="order.state===1?'color:#FFA000':'color:#C1C1C1'"></i>
        <span v-if="order.state===2"
              style="color:#00C7BF">已支付</span>
        <span v-else-if="order.state===1"
              style="color:#FFA000">待支付</span>
        <span v-else-if="order.state===6"
              style="color:#C1C1C1">已取消</span>
        <span v-else-if="order.state===4"
              style="color:#C1C1C1">已退款</span>
        <span v-else
              style="color:#C1C1C1">已超时</span>
      </p>
      <p class="order-number">订单号：{{order.order_no}}</p>
      <p class="order-time">下单时间：{{order.order_at|formatYMDHMS}}</p>
      <div class="phone_btn">
        <el-button type="primary"
                   class="order-nobtn"
                   v-if="order.state===1"
                   @click="goPay(order.order_no)">
          立即支付(剩余&nbsp;&nbsp;<span>{{timestamp|payCountDown}})</span>
        </el-button>
        <el-button v-if="showAddCard&&order.various[0].activity_type!==2"
                   type="primary"
                   class="order-nobtn"
                   :disabled="addCarDisabled"
                   plain
                   @click="addCart">重新加入购课单
        </el-button>
        <div class="cancel"
             v-if="order.state===1"
             @click="cancelPay(order.order_no)">取消订单</div>
      </div>
    </div>
    <!-- 收货信息 -->
    <div class="order-address-info"
         v-if="hasAddress">
      <h3 class="order-title">
        <span class="front-line"></span>收货信息
      </h3>
      <p class="order-address-content hidden-xs-only">
        {{ order.receiver }}&nbsp;&nbsp;&nbsp;{{ order.mobile }}&nbsp;&nbsp;&nbsp;{{ order.province }}&nbsp;&nbsp;&nbsp;
        {{ order.city }}&nbsp;&nbsp;&nbsp;{{ order.district }}&nbsp;&nbsp;&nbsp;{{ order.address }}
      </p>
      <p class="order-address-content xs">
        {{ order.receiver }}
        {{ order.mobile }}
        <br><br>{{ order.province }}&nbsp;&nbsp;&nbsp;{{ order.city }}&nbsp;&nbsp;&nbsp;{{ order.district }}
        <br><br>{{ order.address }}
      </p>
    </div>
    <!-- 课程信息 -->
    <h3 class="order-title">
      <span class="front-line"></span>课程清单
    </h3>
    <div class="order-detail-classinfo-container new">
      <div class="order-detail-classinfo-goodsinfo">
        <div class="order-detail-classinfo-goodsinfo-thead">
          <div>课程名称</div>
          <div class="text-center">截止有效期</div>
          <div class="text-center">价格</div>
          <div class="text-right">
            <span style="padding: 0 28px;">操作</span>
          </div>
        </div>
        <div class="order-detail-classinfo-new-tbody">
          <slot v-for="item in order.classList">
            <div :key="item.class_id"
                 class="class-list-wrap"
                 :class="{'union-container': item.union_id !== 0 && item.activity_type === 2}">
              <div class="union-header-info clearfix"
                   v-if="item.union_id !== 0 && item.activity_type === 2">
                <span class="sprite-lbshen lianbao-tag pull-left"></span>
                <span class="union-header-link pull-left">
                  {{ item.youhuiInfo }}</span>
                <span v-if="item.material_count"
                      class="union-header-gift pull-right">
                  <i class="fa fa-huangzeng"></i>联报赠品*{{ item.material_count }}
                </span>
              </div>
              <div v-for="(item, index) in item.various"
                   :key="index"
                   :class="'singleCourse five ' + (item.activity_id !== 0 && item.activity_type === 2 ? 'union':'general')">
                <div class="hidden-xs-only"
                     style="position: relative;">
                  <img @click="goCourse(item, true)"
                       :src="item.cover"
                       alt="">
                </div>
                <div>
                  <h4 @click="goCourse(item, true)">
                    {{ item.subject }}
                    <span v-if="item.goods_type===13">| 教材费</span>
                    <span v-else>| 共{{ item.subclasses_count }}节</span>
                  </h4>
                  <div class="show-mobile time-block">
                    有效期：
                    <slot v-if="item.state === 2 || item.state === 5">{{ item.deadline_at }}</slot>
                    <slot v-else>{{item.duration && item.duration.date}}</slot>
                  </div>
                  <div v-if="item.material_count"
                       class="gift-block"
                       data-id="<%= el.material_temp_id %>">
                    <i class="fa fa-zeng"></i>教材&福利*{{ item.material_count }}
                  </div>
                </div>
                <div class="hidden-xs-only">
                  <div v-if="item.goods_type!==13">
                    <slot v-if="item.state === 2 || item.state === 5">{{ item.deadline_at }}</slot>
                    <slot v-else>{{item.duration && item.duration.date}}</slot>
                  </div>
                </div>
                <div>
                  <slot v-if="order.isGroup || item.isLianBao || item.coupon_id > 0">
                    <span class="delete-price"
                          v-if="item.goods_type!==13">¥{{ Number((item.total_price / 100).toFixed(2)) }}</span><br>
                  </slot>
                  <span :class="{'group-price': order.isGroup, 'union-price': item.isLianBao, 'general-price': !order.isGroup && !item.isLianBao }">¥{{ item.real_price }}</span>
                  <!-- <el-tooltip class="item"
                              v-if="item.material_goods_id>0"
                              effect="dark"
                              :content="'含'+(item.material_goods_price/ 100).toFixed(2) +'元教材费'"
                              placement="top-start">
                    <i class="el-icon-warning-outline"
                       style="color:#FFA000;margin-left: 3px;"></i>
                  </el-tooltip> -->
                  <slot v-if="order.isGroup || item.isLianBao">
                    <br><span :class="{'group-tag': order.isGroup, 'union-tag': item.isLianBao}"
                          v-if="item.goods_type!==13">{{ order.isGroup ? '团购价':'联报价'}}</span>
                  </slot>
                  <slot v-if="item.subclasses_count !== item.various.length">
                    <br><span class="left-tag">剩余{{ item.various.length }}章节</span>
                  </slot>
                </div>
                <div class="btn-group">
                  <div v-if="item.goods_type!==13">
                    <el-button v-if="showShareBtn"
                               type="danger"
                               class="lookclass"
                               @click="showGroup">分享完成拼团</el-button>
                    <el-button v-if="canWatchClass(item)"
                               type="primary"
                               @click="goCourse(item)"
                               class="lookclass">
                      去看课
                    </el-button>
                    <div v-if="canRefund(item)"
                         class="order-refund"
                         @click="getRefundAmount(item.order_no)">
                      申请退款
                    </div>
                    <div class="order-refund"
                         v-if="item.state===4 && item.refund_money">
                      已退款¥{{ item.refund_money / 100 }}
                    </div>
                    <div class="order-refund has-refund"
                         v-if="item.state === 8">退款中</div>
                  </div>
                  <div v-if="item.goods_type===13&&item.refund_money">
                    已退款¥{{Number((item.refund_money / 100).toFixed(2))}}
                  </div>
                </div>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </div>
    <!-- 价格信息 -->
    <div class="order-count clearfix">
      <table>
        <tbody>
          <tr>
            <td class="text">合计金额：</td>
            <td class="price">¥{{order.total_price}}</td>
          </tr>
          <tr>
            <td class="text">活动优惠：</td>
            <td class="price">
              -¥{{Math.max(Number(((order.total_price - order.real_price - order.total_coupon_price)).toFixed(2)),0)}}
            </td>
          </tr>
          <tr>
            <td class="text">礼券优惠：</td>
            <td class="price">-¥{{ order.total_coupon_price }}</td>
          </tr>
          <tr class="">
            <td class="text">应付金额：</td>
            <td class="price truly-price"
                :class="{ 'group-price': order.isGroup }">¥{{order.real_price}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 付款信息 -->
    <div class="table-info"
         v-if="order.state===2">
      <div>交易流水号：{{order.payment_no}}</div>
      <div>支付时间：{{order.charge_at}}</div>
      <div>支付金额：<span :style="groupState?'color:#EF4D3C':'color:#FFA000'">¥{{order.real_price}}</span>&nbsp;({{order.channel}})
      </div>
    </div>
    <RefundHandle ref="RefundHandle"
                  :refundSuccess="getOrderInfo" />
    <!-- <Lianbao v-if="showLianbao"
             :closeCB="closeLianBaoModal"
             :goods-id-props="goods_id"
             mode-type="readonly"
             :orderId="order_id"
             :courses-in-cart-props="[]"></Lianbao> -->
  </div>
</template>
<script>
import $ from 'jquery'
import api from '@/api'
import moment from 'moment'
import * as _ from 'underscore'
import utils from '@/utils/utils'
import { mapActions } from 'vuex'
// import Lianbao from '@/components/LianBaoModal'
import { STATE_MAP, productTypeMap } from '@/utils/constants'
import RefundHandle from '@/components/RefundHandle'

export default {
  data: function () {
    return {
      orderNo: 0,
      timestamp: '',
      stateMap: STATE_MAP,
      order: {
        goods_type: 7
      },
      loading: true,
      coupon_id: 0,
      goods_type: 2,
      addCarDisabled: false,
      material_arr: [],
      showLianbao: false,
      goods_id: 0,
      order_id: 0
    }
  },
  components: { RefundHandle },
  methods: {
    ...mapActions(['addCar']),
    addCart (e) {
      const $element = $(e.currentTarget)
      const goodsIds = []
      this.order.various.forEach((singleOrder) => {
        goodsIds.push(singleOrder.goods_id)
      })
      if (goodsIds && goodsIds.length) {
        this.addCar({
          goodsIds,
          goodsType: this.order.various[0].goods_type,
          callback: () => {
            utils.ballAnimation($element)
            this.addCarDisabled = true
          }
        })
      }
    },
    showLianBaoInfo (item) {
      for (let i = 0; i < item.various.length; i++) {
        if (item.various[i].goods_type === 5) {
          this.goods_id = item.various[0].goods_id
          this.order_id = item.various[0].order_no
          this.showLianbao = true
          return
        }
      }
    },
    closeLianBaoModal () {
      this.showLianbao = false
    },
    getRefundAmount (orderNo) {
      this.$refs.RefundHandle.getRefundAmount(orderNo, $.extend(true, {}, this.order))
    },
    // 取消订单
    cancelPay (orderNo) {
      this.$showDialog('确认取消订单', () => {
        api.cancelOrder({ order_no: orderNo }).then(res => {
          if (res.data.code === 1) {
            this.getOrderInfo()
          } else {
            this.$message.warning(res.data.message)
          }
          this.loading = false
        })
      })
    },
    getOrderInfo () {
      api.queryOrderNew({ order_no: this.orderNo }).then(res => {
        if (res.data.code === 1 && res.data.data) {
          if (res.data.data.product_type === productTypeMap.SVIP) {
            this.$router.push({ name: 'NotFound' })
            return false
          }
          this.order = this.processData(res.data.data || {})
          if (this.order.state === 1) {
            this.startTimer()
          }
          this.loading = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getClassDutation (info) {
      const now = moment()
      const beginAt = moment(info.begin_at * 1000)
      const endAt = moment(info.end_at * 1000)
      let time = ''
      let date = ''
      if (info.time_cycle) {
        const timeCycle = JSON.parse(info.time_cycle)
        time = `${timeCycle[0].begin_at}-${timeCycle[timeCycle.length - 1].end_at}`
      }
      if (beginAt.year() !== now.year() || beginAt.year() !== endAt.year()) {
        date = `${beginAt.format('YYYY.MM.DD')} - ${endAt.format('YYYY.MM.DD')}`
      } else {
        date = `${beginAt.format('MM月DD日')} - ${endAt.format('MM月DD日')}`
      }
      return { date, time }
    },
    changeOrigin (obj) {
      if ((obj.various.length === 1) && (obj.order_no === obj.various[0].order_no)) {
        obj.channel = obj.various[0].channel.includes('ali') ? '支付宝' : obj.various[0].channel.includes('wx') ? '微信' : obj.various[0].channel.includes('zxb') ? '质心币' : '其他'
        obj.charge_at = moment((obj.various[0].charge_at || 0) * 1000).format('YYYY-MM-DD HH:mm:ss')
        obj.payment_no = obj.payment_no || obj.various[0].payment_no
      } else {
        if (Number(obj.state) === 2) {
          obj.channel = obj.channel.includes('ali') ? '支付宝' : obj.channel.includes('wx') ? '微信' : obj.channel.includes('zxb') ? '质心币' : '其他'
          obj.charge_at = moment((obj.charge_at || 0) * 1000).format('YYYY-MM-DD HH:mm:ss')
        }
      }
    },
    processData: function (order) {
      const a = JSON.parse(JSON.stringify(order))
      a.real_price = Number((order.real_price / 100).toFixed(2))
      // 主、子订单号相同，说明是单独下单的课程外面包了一层
      this.changeOrigin(a)
      a.total_coupon_price = 0
      a.various.forEach(el => {
        el.activity_type = Number(el.activity_type)
        el.real_price = Number((el.real_price / 100).toFixed(2))
        el.cover = el.cover || (process.env.VUE_APP_IMAGE_DEFAULT_ORIGIN + '/img/live/default-cover.png')
        el.state = Number(el.state)
        if (el.state !== 2) {
          el.duration = this.getClassDutation({
            begin_at: el.begin_at,
            time_cycle: el.time_cycle,
            end_at: el.end_at
          })
        } else {
          el.deadline_at = moment(el.deadline_at * 1000).format('YYYY年MM月DD日')
        }

        let canRefund = el.can_refund
        if (el.activity_type === 1 && el.activity_info) {
          canRefund = canRefund && el.activity_info.can_refund && (el.activity_info.state - 0 !== 1)
        }
        if (el.coupon_id > 0) {
          a.total_coupon_price += el.coupon_price
        }
        el.canRefund = canRefund
        el.isStation = el.course_belong === '质心灵动量'
        el.isLianBao = el.union_id !== 0 && Number(el.activity_type) === 2
      })
      a.isGroup = Number(a.various[0].activity_type) === 1
      a.total_coupon_price = Number((a.total_coupon_price / 100).toFixed(2))
      a.total_price = Number((a.total_price / 100).toFixed(2))
      a.group_set = a.various.some(el => {
        return el.group_set
      })
      a.isStation = a.various && a.various.length && a.various[0].course_belong === '质心灵动量'
      a.state = Number(a.state)
      if (a.address_snapshot && JSON.stringify(a.address_snapshot) !== '{}') {
        a.receiver = a.address_snapshot.receiver
        a.mobile = a.address_snapshot.mobile
        a.province = a.address_snapshot.province
        a.city = a.address_snapshot.city
        a.district = a.address_snapshot.district
        a.address = a.address_snapshot.address
      }
      this.setUnionInfo(a)
      return a
    },
    setUnionInfo (obj) {
      obj.various.forEach(el => {
        this.setMaterialInfo(el)
      })
      if (obj.union_info && Array.isArray(obj.union_info) && obj.union_info.length > 0) {
        this.setGroups(obj)
      } else {
        this.sortByDate(obj.various)
        obj.classList = [{
          union_id: 0,
          activity_type: 0,
          various: obj.various
        }]
      }
    },
    setGroups (obj) {
      obj.various.forEach(el => {
        el.union_id = el.activity_id
      })
      const a = _.groupBy(obj.various, 'activity_id')
      let allClasses = a['0'] || []
      for (const key in a) {
        if (key !== '0' && Object.prototype.hasOwnProperty.call(a, key)) {
          const b = this.gatherGroup(a[key], obj.union_info, obj.order_at)
          if (b.notUnion) {
            allClasses = allClasses.concat(b.class_list)
          } else {
            this.setMaterialInfo(b)
            b.youhuiInfo = b.discount_type === 1 ? `已打${b.discount_val / 10}折` : `已减${Number((b.discount_val / 100).toFixed(2))}元`
            allClasses.push(b)
          }
        }
      }
      this.sortByDate(allClasses)
      obj.classList = this.resetGroup(allClasses)
      // console.log(obj.classList)
    },
    resetGroup (classes) {
      const arrOut = []
      for (let i = 0; i < classes.length; i++) {
        if (i === 0) {
          if (classes[0].union_id === 0) {
            arrOut.push({
              union_id: 0,
              various: [JSON.parse(JSON.stringify(classes[0]))]
            })
          } else {
            arrOut.push(JSON.parse(JSON.stringify(classes[0])))
          }
        } else {
          if (classes[i].union_id !== arrOut[arrOut.length - 1].union_id) {
            if (classes[i].union_id === 0) {
              arrOut.push({
                union_id: 0,
                various: [JSON.parse(JSON.stringify(classes[i]))]
              })
            } else {
              arrOut.push(JSON.parse(JSON.stringify(classes[i])))
            }
          } else {
            arrOut[arrOut.length - 1].various.push(JSON.parse(JSON.stringify(classes[i])))
          }
        }
      }
      return arrOut
    },
    gatherGroup (truth, faker, orderAt) {
      truth = JSON.parse(JSON.stringify(truth))
      const a = faker.find(el => {
        return el.union_id === truth[0].union_id
      })
      a.class_list = Array.isArray(a.class_list) ? a.class_list : []
      a.gift_list = Array.isArray(a.gift_list) ? a.gift_list : []
      if (truth.length !== a.class_list.length) {
        truth.forEach(el => {
          el.union_id = 0
        })
        return {
          notUnion: true,
          class_list: truth
        }
      }
      if (a.begin_at > orderAt) {
        truth.forEach(el => {
          el.union_id = 0
        })
        return {
          notUnion: true,
          class_list: truth
        }
      }
      const b = JSON.parse(JSON.stringify(a.class_list))
      let maxIncart = 0
      for (let i = 0; i < b.length; i++) {
        const c = truth.find(el => {
          return el.class_id - 0 === b[i].class_id - 0
        })
        b[i] = c
        maxIncart = c.in_cart_at > maxIncart ? c.in_cart_at : maxIncart
      }
      return {
        union_id: a.union_id,
        various: b,
        notUnion: false,
        in_cart_at: maxIncart,
        // material_info: a.materials_info,
        title: a.title,
        discount_type: a.discount_type,
        activity_type: 2,
        activity_id: a.union_id,
        discount_val: a.discount_val,
        material_info: a.gift_list
      }
    },
    sortByDate (data) {
      data.sort(function (a, b) {
        const a1 = a.in_cart_at
        const a2 = b.in_cart_at
        return a1 - a2 > 0 ? -1 : 1
      })
    },
    setMaterialInfo (obj) {
      if (!obj.material_info || obj.material_info.length === 0) return
      let a = 0
      obj.material_info.forEach(el => {
        el.quantity = el.quantity ? el.quantity : el.num
        el.name = el.name ? el.name : el.subject
        a += Number(el.quantity)
      })
      obj.material_temp_id = this.material_arr.length
      this.material_arr.push({
        infos: obj.material_info
      })
      obj.material_count = a
    },
    startTimer () {
      if (Number(this.order.state) !== Number(this.stateMap.NOT_PAY)) return
      const payEndTime = Number(this.order.order_at) + 30 * 60
      this.timestamp = Math.floor(payEndTime) - Math.floor($.now() / 1000)
      if (Number(this.timestamp) < 1) {
        this.order.state = 3
      }
      this.timer = window.setInterval(() => {
        if (Number(this.timestamp) < 1) {
          this.order.state = 3
          clearInterval(this.timer)
        } else {
          this.timestamp -= 1
        }
      }, 1000)
    },
    goPay (orderNo) {
      this.zhuGeEventTrack(this.zhugeEvents.MY_CLASS.GO_PAY_CLICK)
      this.$router.push({ path: '/pay/' + orderNo })
    },
    getMyCourseDetail (item, flag) {
      const hash = flag ? 'class-detail' : 'mycourse-detail'
      return '/' + hash + '/' + item.class_id + (Number(item.goods_type) === 5 ? '/offline' : '/live')
    },
    goCourse (item, flag) {
      if (Number(item.goods_type) === 13) {
        return false
      }
      const hash = flag ? 'livereg' : 'mineLives'
      if (item.isStation || Number(item.goods_type) === 5) {
        this.$router.push({ path: this.getMyCourseDetail(item, flag) })
      } else {
        window.open(`${process.env.VUE_APP_ZHIXIN_URL}/#${hash}/${item.class_id}`)
      }
    },
    // 分享团购
    showGroup () {
      this.$router.push({
        path: '/groupActivity/' + this.order.various[0].activity_info.group_id,
        query: { isPaided: true }
      })
    },
    canWatchClass (item) {
      return ((item.state === 8 || item.state === 4) && item.can_watch) || (item.state === 2 && (!this.groupState || (this.groupState && this.groupSuccess === 2)))
    },
    canRefund (item) {
      return item.canRefund && item.state === 2 && (!this.groupState || (this.groupState && this.groupSuccess === 2))
    }
  },
  computed: {
    groupState () {
      let groupInfo = {}
      this.order.various.forEach(item => {
        if (item.goods_type === 5 || item.goods_type === 2) {
          groupInfo = item
        }
      })
      // console.log('as', this.order.various)
      // return this.order.various && this.order.various.length && Number(this.order.various[0].activity_type) === 1
      return this.order.various && this.order.various.length && Number(groupInfo.activity_type) === 1
    },
    groupSuccess () {
      // const orderInfo = this.order.various[0]
      let orderInfo = {}
      this.order.various.forEach(item => {
        if (item.goods_type === 5 || item.goods_type === 2) {
          orderInfo = item
        }
      })
      if (orderInfo && orderInfo.activity_info) {
        return Number(orderInfo.activity_info.state)
      } else {
        return 2
      }
    },
    showAddCard () {
      return (Number(this.order.state) === Number(this.stateMap.TIMEOUT) || Number(this.order.state) === Number(this.stateMap.HAS_CANCELED)) && !this.order.isGroup
    },
    hasAddress () {
      return this.order.various && this.order.various.length && this.order.various[0].address_id > 0
    },
    showShareBtn () {
      // console.log('pay', this.groupState, Number(this.order.state) === 2, this.groupSuccess)
      return this.groupState && Number(this.order.state) === 2 && this.groupSuccess === 1
    }
  },
  created () {
    this.orderNo = this.$route.params.orderNo
    this.getOrderInfo()
    $('#zhixin-app').css('background', 'white')
  },
  beforeDestroy () {
    $('#zhixin-app').css('background', '#edeff2')
  }
}
</script>
<style lang="scss" src="../../assets/scss/_lianbao_tag.scss"></style>
<style lang="scss" scoped>
@import "@/assets/scss/partials/_order_detail.scss";

.pay-confirm {
  max-width: 1140px;
  margin: auto;

  .order-xz {
    border-radius: 2px;
    border: 1px solid rgba(51, 51, 51, 0.1);
    margin: 16px 0 40px 0;
    box-sizing: border-box;
    padding: 19px 29px 19px 32px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 24px;

    .order-number,
    .order-time {
      font-size: 14px;
      font-weight: 400;
      color: rgba(51, 51, 51, 0.8);
    }

    .order-state {
      font-size: 20px;
      font-weight: 500;
      line-height: 20px;
      margin-bottom: 20px;

      i {
        font-size: 22px;
        margin-right: 12px;
      }
    }

    .order-nobtn {
      width: 187px;
      height: 40px;
      float: right;
      margin-top: 16px;
    }

    .order-nobtn {
      position: absolute;
      top: 30px;
      right: 35px;
    }

    .cancel {
      position: absolute;
      right: 90px;
      top: 92px;
      color: rgba(51, 51, 51, 0.4);
      cursor: pointer;
    }
  }

  .order-title {
    padding: 0;
    margin: 0 0 16px;
    position: relative;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    line-height: 16px;
    text-indent: 0.5em;

    .front-line {
      position: absolute;
      left: 0;
      top: 0;
      width: 2px;
      height: 100%;
      background: #00c7bf;
    }
  }

  .order-address-info {
    padding-top: 8px;
    margin-bottom: 32px;

    .order-address-content {
      margin: 0;
      padding: 21px 24px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(51, 51, 51, 0.8);
      line-height: 14px;
      border: 1px solid rgba(51, 51, 51, 0.1);
      border-radius: 2px;

      &.xs {
        display: none;
      }
    }
  }

  .table-info {
    text-align: right;
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 0.6);
    line-height: 14px;
    margin-bottom: 20px;

    > div {
      display: inline-block;
      margin-bottom: 5px;
      margin-right: 40px;
    }
  }

  .class-list-wrap {
    margin-bottom: 16px;
  }

  .order-count {
    padding: 16px 32px 8px;
    background: rgba(51, 51, 51, 0.03);
    border-radius: 2px;
    margin-bottom: 24px;

    table {
      float: right;
      border: none;
      margin: 0;
      padding: 0;

      td {
        font-size: 14px;
        font-weight: 400;
        line-height: 14px;
        padding: 8px 0;
        border: none;
      }

      .text {
        color: rgba(51, 51, 51, 0.6);
      }

      .price {
        text-align: right;
        color: rgba(51, 51, 51, 0.8);
      }

      .truly-price {
        padding: 16px 0 16px 16px;
        font-size: 22px;
        font-weight: 500;
        color: #ffa000;
        line-height: 22px;
      }
    }
  }

  .order-refund {
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 0.8);
    line-height: 14px;
    padding: 10px 5px;

    &.has-refund {
      padding: 10px 2px;
    }
  }

  .fa-huangzeng {
    color: rgb(255, 160, 0);
    margin-right: 5px;
  }

  .fa-zeng {
    color: rgb(0, 199, 191);
    margin-right: 5px;
  }

  .order-count table .truly-price {
    &.group-price {
      color: #ef4d3c;
    }
  }

  @media (max-width: 767px) {
    & {
      margin-bottom: 18px;
      max-width: 355px;

      .order-xz {
        border: none;
        padding: 0;
        overflow: hidden;
        margin: 16px 0 21px 0;

        .phone_btn {
          text-align: right;
          > div,
          button {
            position: static;
            display: inline-block;
          }
        }
        .phone_btn .cancel {
          margin-top: 24px;
          margin-right: 10px;
        }
      }

      .order-address-info .order-address-content.xs {
        display: block;
      }
    }
  }
}
</style>
